import { render, staticRenderFns } from "./index.vue?vue&type=template&id=78735346&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Avatar/index.vue').default,TextareaComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/TextareaComponent/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default,Comment: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Comment/index.vue').default})
